import api from '../utils/api'
const expenseService = {

    // Get all expenses with filtering
    getAllExpenses: async (params = {}) => {
        try {
            const response = await api.get('/api/expenses', { params })
            return response.data // API returns { success, data, pagination, categories, statusCounts }
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Get expense by ID
    getExpenseById: async (id) => {
        try {
            const response = await api.get(`/api/expenses/${id}`)
            return response.data.data // API returns { success, data: { ...expense, items } }
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Create new expense
    createExpense: async (expenseData) => {
        try {
            const response = await api.post('/api/expenses', expenseData)
            return response.data
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Update expense
    updateExpense: async (id, expenseData) => {
        try {
            const response = await api.put(`/api/expenses/${id}`, expenseData)
            return response.data
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Delete expense
    deleteExpense: async (id) => {
        try {
            const response = await api.delete(`/api/expenses/${id}`)
            return response.data
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Approve expense
    approveExpense: async (id) => {
        try {
            const response = await api.put(`/api/expenses/${id}/approve`)
            return response.data
        } catch (error) {
            throw error.response?.data || error
        }
    },
    previewAccountingPosting: async (id, params = {}) => {
        try {
            const query = { ...params }
            if (query.account_overrides) query.account_overrides = JSON.stringify(query.account_overrides)
            const response = await api.get(`/api/accounting/expenses/${id}/preview`, { params: query })
            return response.data
        } catch (error) {
            throw error.response?.data || error
        }
    },
    postToAccounting: async (id, options = {}) => {
        try {
            const response = await api.post(`/api/accounting/expenses/${id}/post`, options)
            return response.data
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Get expense categories
    getCategories: async () => {
        try {
            const response = await api.get('/api/expenses/categories/list')
            return response.data // API returns { success, data, defaultCategories }
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Get dashboard stats
    getDashboardStats: async (params = {}) => {
        try {
            // Default period to 'month' if not provided
            const queryParams = { period: 'month', ...params };
            const response = await api.get('/api/expenses/dashboard/stats', {
                params: queryParams
            })
            return response.data.data // API returns { success, data: { ...stats, expensesByCategory } }
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Upload file (you may need to implement upload endpoint separately)
    uploadFile: async (file, folder = 'general') => {
        try {
            const formData = new FormData()
            formData.append('file', file)
            formData.append('folder', folder)
            // Note: This endpoint may need to be implemented separately from expenses API
            const response = await api.post('/uploads', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return response.data
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Upload multiple files  
    uploadMultipleFiles: async (files, folder = 'general') => {
        try {
            const formData = new FormData()
            files.forEach((file) => {
                formData.append('files', file)
            })
            formData.append('folder', folder)
            // Note: This endpoint may need to be implemented separately from expenses API
            const response = await api.post('/uploads/multiple', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return response.data
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Search expenses (uses getAllExpenses with search parameter)
    searchExpenses: async (searchTerm, otherParams = {}) => {
        try {
            const response = await api.get('/api/expenses', {
                params: { search: searchTerm, ...otherParams }
            })
            return response.data.data // Returns expenses array
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Get expenses by category (uses getAllExpenses with category filter)
    getExpensesByCategory: async (category, otherParams = {}) => {
        try {
            const response = await api.get('/api/expenses', {
                params: { category, ...otherParams }
            })
            return response.data.data // Returns expenses array
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Get expenses by status (uses getAllExpenses with status filter)
    getExpensesByStatus: async (status, otherParams = {}) => {
        try {
            const response = await api.get('/api/expenses', {
                params: { status, ...otherParams }
            })
            return response.data.data // Returns expenses array
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Get expenses by supplier (uses getAllExpenses with supplier_id filter)
    getExpensesBySupplier: async (supplierId, otherParams = {}) => {
        try {
            const response = await api.get('/api/expenses', {
                params: { supplier_id: supplierId, ...otherParams }
            })
            return response.data.data // Returns expenses array
        } catch (error) {
            throw error.response?.data || error
        }
    },
    // Get next expense number
    generateExpenseNumber: async (date) => {
        try {
            const response = await api.get('/api/expenses/generate-number', { params: { date } })
            return response.data.expense_number
        } catch (error) {
            throw error.response?.data || error
        }
    }
}
export default expenseService
